import { hasPremiumUserSelect } from 'modules/training/modules/training-users/selectors/has-premium'
import { createSelector } from 'reselect'
import {
  isAndroidPlatformUtil,
  isApplePlatformUtil
} from 'utils/device/utils/get-platform'
import isCheckingIosAppSelect from 'modules/training/modules/app/selectors/isCheckingIos'
import isCheckingAndroidAppSelect from 'modules/training/modules/app/selectors/isCheckingAndroid'
import getUserAgentAppSelect from 'modules/training/modules/app/selectors/get-user-agent'
import { getObjectUtil } from 'packages/src'
import { TRAINING_APP_PATH } from 'modules/training/modules/app/constants/index.js'

const isFromAppSelect = (state) => {
  return /app/gi.test(getObjectUtil(state, TRAINING_APP_PATH.FROM_PLATFORM))
}

const shouldHidePremiumFeaturesAppSelect = createSelector(
  hasPremiumUserSelect,
  isCheckingIosAppSelect,
  isCheckingAndroidAppSelect,
  getUserAgentAppSelect,
  isFromAppSelect,
  (
    userHasPremium,
    isCheckingIos,
    isCheckingAndroid,
    userAgent
    // isFromApp
  ) => {
    if (userHasPremium) {
      return false
    }

    // if (!isFromApp) {
    //   return false
    // }

    const isApple = isApplePlatformUtil(userAgent)
    const isAndroid = isAndroidPlatformUtil(userAgent)

    if (isCheckingIos && isApple) {
      return true
    }

    if (isCheckingAndroid && isAndroid) {
      return true
    }

    return false
  }
)

export default shouldHidePremiumFeaturesAppSelect
